import React from 'react';
import LandlordMaintenanceContainer from '../../components/landlord-dashboard/maintenance/LandlordMaintenanceContainer';
import { useAuth } from '../../auth/firebaseAuth';
import { Navigate } from 'react-router-dom';
import LandlordToolkitLayout from '../../components/landlord-toolkit/LandlordToolkitLayout';

const MaintenanceRequestsPage: React.FC = () => {
  const { currentUser, userProfile } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If a renter somehow gets here, redirect them to their own page
  if (userProfile?.role === 'renter') {
    return <Navigate to="/tenant/maintenance" replace />;
  }

  return (
    <LandlordToolkitLayout title="Maintenance Requests">
      <LandlordMaintenanceContainer />
    </LandlordToolkitLayout>
  );
};

export default MaintenanceRequestsPage;
